var PREFIX_FOR_TEST_IDS = 'federal-rule-form';

/** test ids for form and sections inside it */
export var TestIds = {
  FEDERAL_RULE_FORM: "".concat(PREFIX_FOR_TEST_IDS, "-test-id"),
  FEDERAL_RULE_PUB_INFO: "".concat(PREFIX_FOR_TEST_IDS, "-federal-rule-pub-info-sec-test-id")
};
export var SECTION_TITLE = 'publication info';